import React from 'react';

const MyAccount = () => {
    return (
        <div>
            <h1>MINHA CONTA</h1>
        </div>
    )
}

export default MyAccount;